const DOMAIN = process.env.REACT_APP_AUTH0_LOGIN_DOMAIN;
const API_DOMAIN = process.env.REACT_APP_AUTH0_API_DOMAIN;
const CLIENT_ID = process.env.REACT_APP_AUTH0_CLIENT_ID;
const AUDIENCE = process.env.REACT_APP_AUTH0_AUDIENCE;

export {
  DOMAIN, CLIENT_ID, AUDIENCE, API_DOMAIN,
};
